import React from "react";
import { getImgPath } from "../common/helper";
import {
  t,
  TAB2_HEADING1,
  TAB2_HEADING2,
  TAB2_LI1,
  TAB2_LI2,
  TAB2_LI3,
  TAB2_LI4,
  TAB2_LI5,
  TAB2_LI6,
  TAB2_LI7,
  TAB2_LI8,
  TAB2_LI9,
  TAB2_LI10,
} from "../../translations/AboutUs/BusServiceAiravatClubClass";

function BusServiceAiravatClubClass() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
      <div style={{ fontSize: "20px", fontWeight: "600", textAlign: "left" }}>
        {t(TAB2_HEADING1)}
      </div>
      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
        <div>
          <img src={getImgPath("/img/aboutus/bus_service/bus4.png")} alt="" />
        </div>
      </div>
      <div style={{ fontSize: "16px", fontWeight: "600", textAlign: "left" }}>
        {t(TAB2_HEADING2)}
      </div>
      <div>
        <ul style={{ margin: "0", padding: "0", marginLeft: "48px" }}>
          <li style={{ fontSize: "14px", fontWeight: "400" }}>{t(TAB2_LI1)}</li>
          <li style={{ fontSize: "14px", fontWeight: "400" }}>{t(TAB2_LI2)}</li>
          <li style={{ fontSize: "14px", fontWeight: "400" }}>{t(TAB2_LI3)}</li>
          <li style={{ fontSize: "14px", fontWeight: "400" }}>{t(TAB2_LI4)}</li>
          <li style={{ fontSize: "14px", fontWeight: "400" }}>{t(TAB2_LI5)}</li>
          <li style={{ fontSize: "14px", fontWeight: "400" }}>{t(TAB2_LI6)}</li>
          <li style={{ fontSize: "14px", fontWeight: "400" }}>{t(TAB2_LI7)}</li>
          <li style={{ fontSize: "14px", fontWeight: "400" }}>{t(TAB2_LI8)}</li>
          <li style={{ fontSize: "14px", fontWeight: "400" }}>{t(TAB2_LI9)}</li>
          <li style={{ fontSize: "14px", fontWeight: "400" }}>
            {t(TAB2_LI10)}
          </li>
        </ul>
      </div>
    </div>
  );
}

export default BusServiceAiravatClubClass;
